import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom';
import { AcademyContext } from '../../../_contexts/UserContext';
import { UserService } from '../../../_services/UserService';
import { LearnerService } from '../../../_services/LearnerService';

import FullScreenLoadingProgress from '../../_commons/FullScreenLoadingProgressComponent/FullScreenLoadingProgress';

import Moment from 'moment';
import { Button, Link as MaterialUILink, Divider, Grid } from '@material-ui/core';

import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import ShopIcon from '@material-ui/icons/Shop';
import UserMetrics from '../UserMetrics/UserMetrics';
import UserBadges from '../UserBadges/UserBadges';
import { UserSSOStatus } from '../UserSSOStatus';
import UserEmailNotificationStatusSwitch from '../UserEmailNotificationStatus';





export default class UserProfile extends Component {

    static contextType = AcademyContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,

            userProfile: {
                learnerId: 0,
                userDisplayName: "",
                userEmail: "",
                registerDate: ""
            },
            enrollments: [],
            membershipState: {
                isMembership: false,
                freeTrialWatchLimitationReached: false,
                membershipStatus: undefined,
                membershipName: "",
                membershipType: "",
                isActive: false,
                lastPurchaseDate: "",
                expiredDate: ""
            },

            courseMembershipPlan: []

        }
        this.syncProgressHandler = this.syncProgressHandler.bind(this);


    }
    syncProgressHandler() {
        let confirmRes = window.confirm('Do you confirm to overwrite learning progress from old platform to new platform?');

        if (confirmRes)
            LearnerService.RequestOverwriteLearningProgress(
                this.context.loginState.accessToken,
                (data) => {
                    //console.log(data);
                    if (data.success) {
                        alert("Overwrite Successfully")
                    }
                    else {
                        alert("Overwrite Failed")
                    }
                }
            );
    }

    componentDidMount() {
        if (this.context.loginState.isLoggedIn) {

            LearnerService.GetLearnerProfileWithEnrollments(
                this.context.loginState.accessToken,
                (data) => {
                    this.setState({
                        userProfile: {
                            learnerId: data.learnerId,
                            userDisplayName: data.userDisplayName,
                            userEmail: data.userEmail,
                            registerDate: data.registerDate
                        },
                        enrollments: data.enrollments || [],
                        loading: false
                    });
                }
            );

        }
    }

    render() {

        if (this.context.loginState.isLoggedIn === false)
            return (<Redirect to="/SignIn" push />)
        else if (this.state.loading)
            return <FullScreenLoadingProgress></FullScreenLoadingProgress>
        else return (
            <div>
                <p>User Name: {this.state.userProfile.userDisplayName}</p>
                <p>Email: {this.state.userProfile.userEmail}</p>
                <p>Register Date: {Moment(this.state.userProfile.registerDate).format("MMMM DD YYYY")}</p>
                {/*<Grid container spacing={1}>
                    <Grid item ><span>LINK your other accounts for more login: </span></Grid>
                    <Grid item > <UserSSOStatus /></Grid>
                </Grid>*/}

                {
                    this.state.enrollments != null
                    && this.state.enrollments.length > 0
                    &&
                    <div>
                        <h3>Course Enrollments:</h3>
                        <ul>
                            {
                                this.state.enrollments.map((enrollment, index) => (
                                    <li key={index}>
                                        <div>
                                            <strong>Product:</strong> {enrollment.productName || 'N/A'}
                                        </div>
                                        <div>
                                            <strong>Status:</strong> {enrollment.enrollmentStatus}
                                        </div>
                                        <div>
                                            <strong>Access Start:</strong> {Moment(enrollment.accessStartDate).format("MMMM DD YYYY")}
                                        </div>
                                        {enrollment.accessEndDate && (
                                            <div>
                                                <strong>Access End:</strong> {Moment(enrollment.accessEndDate).format("MMMM DD YYYY")}
                                            </div>
                                        )}
                                        <div>
                                            <strong>Enrolled:</strong> {Moment(enrollment.createdAt).format("MMMM DD YYYY")}
                                        </div>
                                    </li>
                                ))}
                        </ul>
                    </div>
                }

                <MaterialUILink href="https://shop.radacad.com/login/">
                    <Button variant='outlined' color='primary'
                        className={'myThemeButton'}
                        startIcon={<ShopIcon></ShopIcon>}
                        style={{ textTransform: 'none' }}
                    >
                        View, Modify or Cancel the Subscription
                    </Button>
                </MaterialUILink>
                <div>Daily Email Notification: <UserEmailNotificationStatusSwitch /></div>

                {/* hide temporarilly */}
                {/* <Button variant='outlined' color='secondary'

                    className={'myDangerButton'}
                    onClick={this.syncProgressHandler}
                    startIcon={<GetAppOutlinedIcon></GetAppOutlinedIcon>}
                    >
                    Overwrite Progress from old platform
                 </Button> */}

                <Divider style={{ marginTop: "20px", marginBottom: "10px" }}></Divider>
                <h2>STATS(Beta):</h2>
                <UserMetrics accessToken={this.context.loginState.accessToken}>

                </UserMetrics>

                <Divider style={{ marginTop: "20px", marginBottom: "10px" }}></Divider>
                <h2>Badges:</h2>
                <UserBadges accessToken={this.context.loginState.accessToken}>

                </UserBadges>
            </div >
        )
    }
}

